import type { CarouselAction, CarouselState } from './ScrollingCarousel.types';

/**
 * Reducer for managing child visibility state in the carousel
 */
export const childVisibilityReducer = (
  state: CarouselState,
  action: CarouselAction
): CarouselState => {
  switch (action.type) {
    case 'set_child_visibility': {
      const newChildVisibility = [...state.childVisibility];

      // We do it like this (instead of a map) so that children can be added out of order or async
      // and we always have the right length
      newChildVisibility[action.payload.index] = action.payload.visible;

      return {
        childVisibility: newChildVisibility,
      };
    }
    default:
      return state;
  }
};

/**
 * Calculate the offset needed to position a dot at a specific visual position
 */
export const calculateDotOffset = (
  dotIndex: number,
  visualPositionIndex: number,
  dotWidth: number,
  dotMovementNeeded: number
): number => {
  return (
    (dotIndex + visualPositionIndex) * dotWidth - dotMovementNeeded * dotWidth
  );
};

/**
 * Calculate distances from each dot to the center dot
 */
export const calculateDotDistances = (
  childVisibility: boolean[],
  centerDotIndex: number
): number[] => {
  return childVisibility.map((_, i) => Math.abs(centerDotIndex - i));
};
